module.exports = __webpack_public_path__ + "static/1401_large-51269343d9b4001c255e2a7564387377.jpg";